import { useEffect, useState } from "react";
import { sendAngiSampleRequest, getJobberMarketplaceUrl } from "../../services";
import AuthFlowFrame from "../../components/AuthFlowFrame";
import SidePanel from "../../components/SidePanel";
import { showError } from "../../helpers";
import { Button } from "@jobber/components/Button";
import { Modal } from "@jobber/components";
import { Content } from "@jobber/components/Content";
import { Heading } from "@jobber/components/Heading";
import { Text } from "@jobber/components/Text";
import { Typography } from "@jobber/components/Typography";
import authCompleteImage from "assets/images/auth_complete.png";
import sampleClientImage from "assets/images/sample_client.png";

function Step2() {
    const [jobberMarketplaceUrl, setJobberMarketplaceUrl] = useState("https://secure.getjobber.com/home");

    useEffect(() => {
        (async () => {
            const state = sessionStorage.getItem('state');
            const response = await getJobberMarketplaceUrl(state);
            if (response.data) {
                setJobberMarketplaceUrl(response.data);
            }
        })();
    }, []);

    const [modalOpen, setModalOpen] = useState(false);
    const [modalButtonText, setModalButtonText] = useState("Continue");
    const [redirectingToJobber, setRedirectingToJobber] = useState(false);

    function sendSampleRequest() {
        setModalButtonText("Redirecting to Jobber...");
        setRedirectingToJobber(true);
        (async () => {
            try {
                const state = sessionStorage.getItem('state');
                const response = await sendAngiSampleRequest(state);
                window.open(response.data.jobber_request_url, "_self");
            } catch(e: any) {
                setModalOpen(false)
                setModalButtonText("Continue");
                setRedirectingToJobber(false);
                showError("Unable to create sample request: " + e.message);
            }
        })();
    }

    return (
        <AuthFlowFrame
            pretitle={"You are all set"}
            title={"We’re working on connecting your Angi Leads account!"}
            sidePanel={
                <SidePanel>
                    <Heading level={2}>
                        Get started by creating a <Typography emphasisType={"highlight"}>sample request!</Typography>
                    </Heading>
                    <Text size={"base"}>
                        Want to see how your leads will appear in Jobber? Click the ‘Create a Sample Request’ button below to see it in action!
                    </Text>
                    <Button
                        url={""}
                        label={"Create a Sample Request"}
                        type={"secondary"}
                        onClick={() => setModalOpen(true)}
                    />

                    <Modal
                        title={"Create a sample request"}
                        open={modalOpen}
                        onRequestClose={() => setModalOpen(false)}
                    >
                        <Content>
                            <Text size={"base"}>
                                Experience a sample of what syncs from Angi Leads/HomeAdvisor into Jobber. You can archive your sample client and request at any point.
                            </Text>
                            <img
                                src={sampleClientImage}
                                alt={"Angi Leads sample client"}
                                style={{
                                    maxWidth: "100%",
                                    marginTop: "10px",
                                }}
                            ></img>

                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "var(--space-small)",
                            }}>
                                <Button
                                    label={"Cancel"}
                                    type={"secondary"}
                                    variation={"learning"}
                                    onClick={() => setModalOpen(false)}
                                />
                                <Button
                                    label={modalButtonText}
                                    type={"primary"}
                                    loading={redirectingToJobber}
                                    onClick={sendSampleRequest}
                                />
                            </div>
                        </Content>
                    </Modal>
                </SidePanel>
            }
            sidePanelContained={true}
            step={2}
            totalSteps={2}
            button={{
                link: jobberMarketplaceUrl,
                text: "Return to App Marketplace",
                type: "primary",
                disabled: false,
                loading: false,
            }}
        >
            <Content type={"div"} spacing={"base"}>
                <Text size={"large"}>
                    It may take up to 1 business day for Angi Leads to finalize the integration setup. You will receive a confirmation email when the integration is ready.
                </Text>
                <Text size={"large"}>
                    Once completed, all leads you get in Angi Leads will automatically be sent to Jobber so you can win more customers and grow your business!
                </Text>
                <img
                    src={authCompleteImage}
                    alt={"Angi Leads authorization complete"}
                    style={{
                        maxWidth: "100%",
                        marginTop: "10px",
                    }}
                ></img>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step2;
